// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgpp-file-upload-compoent-container .tggp-file-upload-input {
  position: relative;
  width: 132px;
  top: 11px;
  opacity: 0;
  border: 0;
  bottom: 0px;
  right: 180px;
  height: 37px;
}
.tgpp-file-upload-compoent-container .button-padding {
  padding: 8px 25px 10px 25px;
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/component/tgpp-file-upload/tgpp-file-upload.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAAJ;AAGE;EACE,2BAAA;EACA,gBAAA;AADJ","sourcesContent":[".tgpp-file-upload-compoent-container {\n  .tggp-file-upload-input {\n    position: relative;\n    width: 132px;\n    top: 11px;\n    opacity: 0;\n    border: 0;\n    bottom: 0px;\n    right: 180px;\n    height: 37px;\n  }\n\n  .button-padding {\n    padding: 8px 25px 10px 25px;\n    margin-top: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
